import { useRef, useEffect } from 'react'
import TierRewardCard from './TierRewardCard'

interface Tier {
  id: string
  tier: number
  xp_required: number
  free_reward_type: string | null
  free_reward_value: string | null
  premium_reward_type: string | null
  premium_reward_value: string | null
}

interface Props {
  tiers: Tier[]
  currentTier: number
  hasPremiumPass: boolean
  themeColor: string
  onClaim: (tierId: string) => void
}

export default function BattlePassTrack({ tiers, currentTier, hasPremiumPass, themeColor, onClaim }: Props) {
  const activeRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    activeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }, [currentTier])

  return (
    <div className="space-y-1.5">
      {tiers.map(tier => (
        <div
          key={tier.id}
          ref={tier.tier === currentTier + 1 ? activeRef : undefined}
        >
          <TierRewardCard
            tier={tier}
            currentTier={currentTier}
            hasPremiumPass={hasPremiumPass}
            themeColor={themeColor}
            onClaim={onClaim}
          />
        </div>
      ))}
    </div>
  )
}
